module.exports = __webpack_public_path__ + "static/UNITY-Square-Two-1st-floor-traditional_v2-en-b5cbe567ea11f356a080549987afbaac.pdf";